import { useEmojisStore } from '@app/store/zustand';
import { checkIsFreeYat } from '@app/store/zustand/emojis/useEmojisStore';

export function useHasFreeYat(eid?: string) {
    const userEmojis = useEmojisStore();

    if (eid) {
        return checkIsFreeYat(eid);
    }

    // Only 1 yat and 6 emojis is a free Yat.
    return (
        userEmojis && userEmojis.emojis[0] && userEmojis?.emojis.length === 1 && checkIsFreeYat(userEmojis.emojis[0])
    );
}
